import { createUseStyles } from 'react-jss'
import customColors from 'src/config/colorsV2'
import { customMediaQueries, forPhoneOnly } from 'src/config/mediaQueries'

export default createUseStyles({
  selectAllContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: 15,
    paddingRight: 12,
    paddingTop: 27,
    paddingBottom: 27,
    whiteSpace: 'nowrap',
    [forPhoneOnly]: {
      paddingTop: 11,
      paddingBottom: 15,
      fontSize: 14,
    },
  },
  checkboxContainer: {
    width: 760,
    display: 'flex',
    alignItems: 'center',
    [customMediaQueries.lessThan760]: {
      width: '100%',
    },
  },
  showAllSlots: {
    color: customColors['grey-600'],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  selectAllButton: {
    marginLeft: 15,
    [forPhoneOnly]: {
      fontSize: 14,
    },
  },
})
